import React, { useState } from 'react'
import 'react-phone-number-input/style.css'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import PhoneInput from 'react-phone-number-input'
import SendIcon from '@mui/icons-material/Send'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const API_URL = process.env.REACT_APP_API_URL || 'https://hoacc-server.vercel.app'

const Contact: React.FC = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState('')

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        setLoading(true)
        setError('')

        try {
            const response = await fetch(`${API_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name,
                    email,
                    phone,
                    message
                })
            })

            const data = await response.json()

            if (response.ok) {
                setSubmitted(true)
                setName('')
                setEmail('')
                setPhone('')
                setMessage('')

                // Reset success message after 5 seconds
                setTimeout(() => {
                    setSubmitted(false)
                }, 5000)
            } else {
                setError(data.message || 'Failed to send message. Please try again.')
            }
        } catch (err) {
            console.error('Error sending message:', err)
            setError('Unable to send message. Please try again or email us directly at info@afroscapescurls.org')
        } finally {
            setLoading(false)
        }
    }

    return (
        <section className="page-section" id="contact">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">Contact Us</h2>
                    <h3 className="section-subheading text-white">Reach out to the house!</h3>
                </div>
                <form id="contactForm" onSubmit={handleSubmit}>
                    <div className="row align-items-stretch mb-5">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    name="from_name"
                                    id="name"
                                    type="text"
                                    placeholder="Your Name *"
                                    required
                                />
                                <div className="invalid-feedback" data-sb-feedback="name:required">
                                    A name is required.
                                </div>
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    name="reply_to"
                                    id="email"
                                    type="email"
                                    placeholder="Your Email *"
                                    required
                                />
                                <div className="invalid-feedback" data-sb-feedback="email:required">
                                    An email is required.
                                </div>
                                <div className="invalid-feedback" data-sb-feedback="email:email">
                                    Email is not valid.
                                </div>
                            </div>
                            <div className="form-group mb-md-0">
                                {/* <input className="form-control" value={phone} onChange={(e)=>setPhone(e.target.value)}  id="phone" name="phone" type="tel" placeholder="Your Phone" /> */}

                                <PhoneInput
                                    defaultCountry="US"
                                    // useNationalFormatForDefaultCountryValue="true"
                                    className="form-control"
                                    placeholder="Enter phone number"
                                    value={phone}
                                    onChange={(val) => {
                                        const phoneNum: string = val ? val : ''
                                        setPhone(phoneNum)
                                    }}
                                />
                                <div className="invalid-feedback" data-sb-feedback="phone:required">
                                    A phone number is required.
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group form-group-textarea mb-md-0">
                                <textarea
                                    className="form-control"
                                    id="message"
                                    name="message"
                                    placeholder="Your Message (optional)"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    {submitted && (
                        <div className="alert alert-success text-center mb-3" role="alert">
                            <CheckCircleIcon className="me-2" />
                            Thank you! We've received your message and will respond within 24-48 hours.
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger text-center mb-3" role="alert">
                            {error}
                        </div>
                    )}

                    <div className="text-center">
                        <Button 
                            variant="contained" 
                            endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />} 
                            size="large"
                            type="submit"
                            disabled={loading || submitted}
                        >
                            {loading ? 'Sending...' : submitted ? 'Message Sent!' : 'Send Message'}
                        </Button>
                    </div>
                </form>
            </div>
        </section>
    )
}

export default Contact
